import React, { useEffect, useState } from "react";
import useGetPartnerList from "../../hooks/usePartnerList";
import useGetPartnersCustomerDetail from "../../hooks/usePartnersCustomerDetail";
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Typography,
    CircularProgress,
    TextField,
    Autocomplete,
} from "@mui/material";

const LoanPartners = () => {
    const [selectedPartner, setSelectedPartner] = useState(null);

    const onSuccess = (data) => {
        console.log("Request successful", data);
    };
    const onFailure = (err) => {
        console.log("Request failed", err);
    };

    const { data: partnerList, mutate: getPartnerList } = useGetPartnerList(onSuccess, onFailure);
    const { data: partnersCustomerDetail, isPending: isCustomerDetailPending, mutate: getPartnersCustomerDetail } = useGetPartnersCustomerDetail(onSuccess, onFailure);

    useEffect(() => {
        getPartnerList();
    }, [getPartnerList]);

    const handlePartnerChange = (event, newValue) => {
        setSelectedPartner(newValue);
        if (newValue) {
            getPartnersCustomerDetail({ partnerID: newValue.value });
        }
    };

    const partnerOptions = partnerList?.data?.partners?.map(partner => ({
        label: partner.partner,
        value: partner._id
    })) || [];

    const customers = partnersCustomerDetail?.data?.customers || [];

    
	return (
		<div style={{ width: "100%" }} className="_loan_partners_main">
            <Typography style={{ fontSize: "20px", fontWeight: "700" }} gutterBottom>
                Loan Partner and Customer details
            </Typography>
			<Autocomplete
                options={partnerOptions}
                getOptionLabel={(option) => option.label}
                style={{ width: 300 }}
                value={selectedPartner}
                onChange={handlePartnerChange}
                renderInput={(params) => <TextField {...params} label="Select or Search Partner" variant="outlined" />}
            />
            {isCustomerDetailPending ? (
                <CircularProgress style={{ marginTop: "2rem" }} />
            ) : (
                partnersCustomerDetail && (
                    <div style={{ marginTop: "2rem" }}>
                        <h3>Customer Details</h3>
                        <TableContainer component={Paper}>
                            <Table sx={{ minWidth: 650 }} aria-label="simple table">
                                <TableHead>
                                    <TableRow>
                                        <TableCell sx={{ fontWeight: 'bold' }}>Customer ID</TableCell>
                                        <TableCell sx={{ fontWeight: 'bold' }}>Program</TableCell>
                                        <TableCell sx={{ fontWeight: 'bold' }}>Email</TableCell>
                                        <TableCell sx={{ fontWeight: 'bold' }}>Mobile</TableCell>
                                        <TableCell sx={{ fontWeight: 'bold' }}>Campaign Type</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {customers.map((customer) => (
                                        <TableRow
                                            key={customer.cx_id}
                                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                        >
                                            <TableCell component="th" scope="row">
                                                {customer._id}
                                            </TableCell>
                                            <TableCell>{customer.program}</TableCell>
                                            <TableCell>{customer.email}</TableCell>
                                            <TableCell>{customer.mobile}</TableCell>
                                            <TableCell>{customer.campaignType}</TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </div>
                )
            )}
		</div>
	);
};

export default LoanPartners;